"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FilterManager_FieldFieldInputAriaLabel: "Filter field: {0}, operator: {1}",
        }
    });
    var controls;
    (function (controls) {
        var FilterField = /** @class */ (function (_super) {
            __extends(FilterField, _super);
            function FilterField(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * Handles pasting user values.
                 * @internal
                 * @summary Handles pasting user values.
                 * @param event The paste event.
                 */
                _this.OnPaste = function (event) {
                    // Only explicitly handle the "IsOneOf" operator
                    if ($dyn.value(_this.Operator) === $dyn.controls.FilterField.Operators.isOneOf) {
                        var windowObject = window;
                        // Retrieve the clipboard data
                        var clipboardData = (event.clipboardData || windowObject.clipboardData);
                        var values = void 0;
                        // Only continue if there is clipboard data
                        if (clipboardData) {
                            // Retrieve the text from the clipboard
                            var value_1 = clipboardData.getData("text") || "";
                            // Handle the optimized "is one of" experience separate from the legacy experience
                            if ($dyn.value(_this.OptimizedIsOneOfFiltering)) {
                                // replace commas with newlines (so that they're split below)
                                value_1 = value_1.replace(/,/g, "\n");
                                // Split the string into an array of values on newlines and tabs
                                values = value_1.split(/\r?\n|\t/);
                                if (values.length > 1 && values[values.length - 1] === "") {
                                    values.splice(values.length - 1, 1);
                                }
                                // Append the values onto the end of the current values
                                if ($dyn.value(_this.ContainsMoreThanEmptyValue)) {
                                    values = $dyn.value(_this.Values).map(function (val) {
                                        return $dyn.value(val);
                                    }).concat(values);
                                }
                                $dyn.util.removeDuplicateOrEmptyStringArrayEntries(values);
                            }
                            else {
                                // Only handle legacy "is one of" paste events if the event target is based on an input control
                                var targetElement = event.target;
                                var inputContext = $dyn.context(targetElement);
                                if (inputContext && inputContext instanceof $dyn.controls.Input) {
                                    // Determine the index of the input element, ensuring it's a valid index before proceeding
                                    var inputIndex_1 = inputContext.element && inputContext.element.hasAttribute("data-dyn-index") ? parseInt(inputContext.element.getAttribute("data-dyn-index"), 10) : -1;
                                    if (inputIndex_1 > -1) {
                                        // Get the input element and value corresponding to the paste event's target
                                        var inputElement = inputContext.element.querySelector("input");
                                        value_1 = inputElement.value.substr(0, $dyn.ui.selectionStart(inputElement)) + value_1 + inputElement.value.substr($dyn.ui.selectionEnd(inputElement));
                                        // Split the string into an array of values on newlines and tabs
                                        values = value_1.split(/\r?\n|\t/);
                                        // Only override the paste event if the value pasted in is in fact multiple values; otherwise,
                                        // reset the values array so the event is allow to proceed normally
                                        if (values.length > 1) {
                                            // Remove duplicates from the pasted values
                                            $dyn.util.removeDuplicateOrEmptyStringArrayEntries(values);
                                            // Get the current underlying values
                                            var currentValues = $dyn.value(_this.Values).map(function (val, index, vals) {
                                                return $dyn.value(val);
                                            });
                                            // Combine the the pasted values with the current text (inserting it into existing selection as appropriate)
                                            values = currentValues.slice(0, inputIndex_1).concat(values).concat(currentValues.slice(inputIndex_1 + 1, currentValues.length));
                                            $dyn.util.removeDuplicateOrEmptyStringArrayEntries(values);
                                            // If the input index is greater than the new resulting values, set the input index (used for setting focus) as the last index;
                                            // note that we know that there will always be at least one value, so we don't need to verify the length of the array is greater than 0.
                                            if (inputIndex_1 >= values.length) {
                                                inputIndex_1 = values.length ? values.length - 1 : 0;
                                            }
                                            // Get the container of input elements and add a post values render subscription that will handle setting
                                            // appropriate focus as long as that container exists (always should).
                                            var valuesContainer_1 = inputContext.element.parentElement;
                                            if (valuesContainer_1) {
                                                var renderSubFunction = function () {
                                                    window.setTimeout(function () {
                                                        var inputToFocus = valuesContainer_1.querySelector($dyn.format("[data-dyn-index='{0}'] input", inputIndex_1));
                                                        if (inputToFocus) {
                                                            inputToFocus.focus();
                                                        }
                                                    });
                                                };
                                                renderSubFunction.bind(_this);
                                                _this.postRenderValuesSubscriptions.push(renderSubFunction);
                                            }
                                        }
                                        else {
                                            values = undefined;
                                        }
                                    }
                                }
                            }
                            if (values) {
                                // Stop the event from propagating
                                event.preventDefault();
                                event.stopPropagation();
                                // Splice the current Values array, removing all current items and replacing them with the values from the clipboard
                                _this.Values.splice.apply(_this.Values, [
                                    0,
                                    $dyn.length(_this.Values) // Indicate all entries should be removed
                                ].concat(values)); // Include the values that should be added to the 'Values' array
                            }
                        }
                    }
                };
                /**
                 * Handles post render values logic.
                 * @internal
                 */
                _this.postRenderValues = function () {
                    while (_this.postRenderValuesSubscriptions.length) {
                        _this.postRenderValuesSubscriptions.pop()();
                    }
                };
                /**
                 * Modifies the number of values of the filter field to match the operator.
                 * @internal
                 */
                _this.OnOperatorChange = function () {
                    var operator = $dyn.value(_this.Operator);
                    var numValues = $dyn.value(_this.Values).length;
                    if (operator === $dyn.controls.FilterField.Operators.between) {
                        if (numValues > 2) {
                            // More than two values, shorten array to two values.
                            _this.Values.splice(2, numValues - 1);
                        }
                        else {
                            // Two or less values. Push empty string values into the array until it has two elements.
                            for (var iLoop = numValues; iLoop < 2; iLoop++) {
                                _this.Values.push("");
                            }
                        }
                    }
                    else if (operator === $dyn.controls.FilterField.Operators.isOneOf) {
                        if ($dyn.value(_this.OptimizedIsOneOfFiltering)) {
                            // Remove any duplicate or empty entries
                            $dyn.util.removeDuplicateOrEmptyStringArrayEntries(_this.Values);
                        }
                        else {
                            // Two or less values. Push empty string values into the array until it has two elements.
                            for (var jLoop = numValues; jLoop < 2; jLoop++) {
                                _this.Values.push("");
                            }
                        }
                    }
                    else {
                        if (numValues > 1) {
                            // More than one values, shorten array to two values.
                            _this.Values.splice(1, numValues - 1);
                        }
                        else {
                            // One or no values. Push empty string value into array if it has no elements.
                            for (var kLoop = numValues; kLoop < 1; kLoop++) {
                                _this.Values.push("");
                            }
                        }
                    }
                    // Reset the selected index each time the operator get changed
                    _this.selectedIndex = _this.getOperatorIndex(operator);
                };
                if (!_this.Root && parent && parent.Root) {
                    _this.Root = parent.Root;
                }
                if (!$dyn.isObservable(_this.Visible)) {
                    _this.Visible = $dyn.observable(_this.Visible);
                }
                var rootForm = $dyn.shell.getCurrentRootForm();
                var rootFormContext;
                if (rootForm) {
                    rootFormContext = $dyn.context(rootForm);
                }
                _this.OptimizedIsOneOfFiltering = (rootFormContext && rootFormContext.FilterPaneControl && rootFormContext.FilterPaneControl.OptimizedIsOneOfFiltering) || $dyn.observable(false);
                _this.ShowFilterField = $dyn.computed(function () {
                    // FilterField should only be visible if it has a FieldCapability
                    return !!($dyn.value(_this.Visible) && $dyn.value(_this.FieldCapability));
                });
                _this.ShowAddField = $dyn.computed(function () {
                    return $dyn.value(_this.AllowEdit) && $dyn.value(_this.Operator) === $dyn.controls.FilterField.Operators.isOneOf && !$dyn.value(_this.OptimizedIsOneOfFiltering);
                });
                _this.FieldLabel = $dyn.computed(function () {
                    var capabilities = $dyn.value(_this.FieldCapability);
                    if (capabilities == null || capabilities.FieldLabel == null) {
                        return "";
                    }
                    else {
                        return $dyn.value(capabilities.FieldLabel);
                    }
                });
                _this.ShowLookup = $dyn.computed(function () {
                    var capabilities = $dyn.value(_this.FieldCapability);
                    if (capabilities == null || capabilities.ShowLookup == null) {
                        return false;
                    }
                    else {
                        return $dyn.value(capabilities.ShowLookup);
                    }
                });
                _this.TableId = $dyn.computed(function () {
                    var capabilities = $dyn.value(_this.FieldCapability);
                    if (capabilities == null) {
                        return null;
                    }
                    else {
                        return $dyn.value(capabilities.TableId);
                    }
                });
                _this.FieldId = $dyn.computed(function () {
                    var capabilities = $dyn.value(_this.FieldCapability);
                    if (capabilities == null) {
                        return null;
                    }
                    else {
                        return $dyn.value(capabilities.FieldId);
                    }
                });
                _this.fieldName = $dyn.computed(function () {
                    var capabilities = $dyn.value(_this.FieldCapability);
                    if (capabilities == null) {
                        return null;
                    }
                    else {
                        return $dyn.value(capabilities.FieldName);
                    }
                });
                _this.selectedIndex = 0;
                $dyn.observe(_this.Operator, _this.OnOperatorChange);
                if (!$dyn.isObservable(_this.ShownIndex)) {
                    _this.ShownIndex = $dyn.observable(_this.ShownIndex);
                }
                if (!$dyn.isObservable(_this.MenuDisplayed)) {
                    _this.MenuDisplayed = $dyn.observable(_this.MenuDisplayed);
                }
                _this.OperatorLabel = $dyn.computed(function () {
                    return $dyn.controls.FilterDisplay.GetOperatorLabel($dyn.value(_this.Operator), $dyn.value(_this.DataType));
                });
                _this.FieldAriaLabel = $dyn.computed(function () {
                    return $dyn.format($dyn.label("FilterManager_FieldFieldInputAriaLabel"), $dyn.value(_this.FieldLabel), $dyn.value(_this.OperatorLabel));
                });
                _this.DataType = $dyn.computed(function () {
                    var capabilities = $dyn.value(_this.FieldCapability);
                    if (capabilities == null || capabilities.DisplayDataType == null) {
                        // Hide the filterfield if it does not have a valid field capability
                        $dyn.setValue(_this, "Visible", false);
                        return FilterField.DataTypes.None;
                    }
                    else {
                        $dyn.setValue(_this, "Visible", true);
                        return $dyn.value(capabilities.DisplayDataType);
                    }
                });
                _this.InputRoleType = $dyn.computed(function () {
                    var operator = $dyn.value(_this.Operator);
                    var controlRole = "Input";
                    // TODO: Task 1574859 - Date, DateTime, Time and Real are string controls until formatting is supported.
                    if (operator === $dyn.controls.FilterField.Operators.isOneOf && $dyn.value(_this.OptimizedIsOneOfFiltering)) {
                        controlRole = "IsOneOf";
                    }
                    else if (operator !== $dyn.controls.FilterField.Operators.matches) {
                        switch ($dyn.value(_this.DataType)) {
                            case $dyn.controls.FilterField.DataTypes.Integer:
                                controlRole = "Integer";
                                break;
                            case $dyn.controls.FilterField.DataTypes.Int64:
                                controlRole = "Int64";
                                break;
                            case $dyn.controls.FilterField.DataTypes.Real:
                            case $dyn.controls.FilterField.DataTypes.Date:
                            case $dyn.controls.FilterField.DataTypes.UtcDateTime:
                            case $dyn.controls.FilterField.DataTypes.Time:
                                controlRole = "Input";
                                break;
                            default:
                                controlRole = "Input";
                                break;
                        }
                    }
                    return controlRole;
                });
                _this.ContainsMoreThanEmptyValue = $dyn.computed(function () {
                    var e_1, _a;
                    var containsNonEmptyValues = false;
                    try {
                        for (var _b = __values($dyn.value(_this.Values)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var value_2 = _c.value;
                            if ($dyn.value(value_2) !== "") {
                                containsNonEmptyValues = true;
                                break;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return containsNonEmptyValues;
                });
                _this.postRenderValuesSubscriptions = [];
                return _this;
            }
            /**
             * Called when a user selects an operator from the operator dropdown of the filter field.
             * Depending on the new operator, this can cause the child controls to be swapped out,
             * so all invalid values should be cleared first, then the operator can change and the dropdown can close.
             * @internal
             * @param operator The selected operator
             */
            FilterField.prototype.SelectOperator = function (operator) {
                if ($dyn.value(this.Operator) !== operator) {
                    var inputs = $(this.element).find(".input_container");
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < inputs.length; i++) {
                        var control = $dyn.context(inputs[i]);
                        if ($dyn.value(control.IsValid) === false) {
                            // If control is invalid, clear the value in the control to remove the control from the form's invalid list and remove any messages.
                            $dyn.setValue(control, "formattedValue", "", true);
                        }
                    }
                    $dyn.setValue(this, "Operator", operator);
                }
            };
            /**
             * Get the index of the parameter operator in the operator selection dropdown.
             * @internal
             */
            FilterField.prototype.UpdateInitialShownIndex = function () {
                this.ShownIndex(this.selectedIndex);
                // This should be called explicitly since the Click is overriden
                this.MenuDisplayed(true);
            };
            /**
             * Get the index of the parameter operator in the operator selection dropdown.
             * @internal
             */
            FilterField.prototype.getOperatorIndex = function (opValue) {
                var operatorList = FilterField.SupportedOperators($dyn.value(this.DataType), $dyn.value(this.fieldName));
                if (operatorList) {
                    for (var i = 0, len = operatorList.length; i < len; i++) {
                        var operator = operatorList[i];
                        if (operator === opValue) {
                            return i;
                        }
                    }
                }
                return -1;
            };
            return FilterField;
        }($dyn.ui.Control));
        controls.FilterField = FilterField;
        (function (FilterField) {
            var Operators;
            (function (Operators) {
                Operators["matches"] = "Matches";
                Operators["is"] = "Is";
                Operators["isNot"] = "IsNot";
                Operators["contains"] = "Contains";
                Operators["doesNotContain"] = "DoesNotContain";
                Operators["beginsWith"] = "BeginsWith";
                Operators["endsWith"] = "EndsWith";
                Operators["isOneOf"] = "IsOneOf";
                Operators["greaterThan"] = "GreaterThan";
                Operators["lessThan"] = "LessThan";
                Operators["greaterThanOrEqual"] = "GreaterThanOrEqual";
                Operators["lessThanOrEqual"] = "LessThanOrEqual";
                Operators["between"] = "Between";
            })(Operators = FilterField.Operators || (FilterField.Operators = {}));
            var DataTypes;
            (function (DataTypes) {
                DataTypes["String"] = "String";
                DataTypes["Date"] = "Date";
                DataTypes["UtcDateTime"] = "UtcDateTime";
                DataTypes["Time"] = "Time";
                DataTypes["Integer"] = "Integer";
                DataTypes["Int64"] = "Int64";
                DataTypes["Real"] = "Real";
                DataTypes["Enum"] = "Enum";
                DataTypes["Guid"] = "Guid";
                DataTypes["None"] = "";
            })(DataTypes = FilterField.DataTypes || (FilterField.DataTypes = {}));
            /**
             * Fetch the array of operators supported by a given field dataType.
             * @param displayDataType The dataType.
             * @param displayFieldName The fieldName.
             */
            function SupportedOperators(displayDataType, displayFieldName) {
                var supportedOperators = [];
                if (displayFieldName === $dyn.util.dataAreaId) {
                    supportedOperators = [
                        Operators.is,
                        Operators.isOneOf
                    ];
                }
                else if (displayDataType === DataTypes.Date
                    || displayDataType === DataTypes.UtcDateTime || displayDataType === DataTypes.Time) {
                    supportedOperators = [
                        Operators.is,
                        Operators.isNot,
                        Operators.greaterThan,
                        Operators.lessThan,
                        Operators.between,
                        Operators.matches
                    ];
                }
                else if (displayDataType === DataTypes.Integer
                    || displayDataType === DataTypes.Int64 || displayDataType === DataTypes.Real) {
                    supportedOperators = [
                        Operators.is,
                        Operators.isNot,
                        Operators.greaterThanOrEqual,
                        Operators.lessThanOrEqual,
                        Operators.between,
                        Operators.matches
                    ];
                }
                else if (displayDataType === DataTypes.Enum) {
                    supportedOperators = [
                        Operators.is,
                        Operators.isNot,
                        Operators.isOneOf,
                        Operators.matches
                    ];
                }
                else { // Default to operators for String dataType
                    supportedOperators = [
                        Operators.is,
                        Operators.isNot,
                        Operators.contains,
                        Operators.doesNotContain,
                        Operators.beginsWith,
                        Operators.isOneOf,
                        Operators.greaterThan,
                        Operators.lessThan,
                        Operators.matches
                    ];
                }
                return supportedOperators;
            }
            FilterField.SupportedOperators = SupportedOperators;
            /**
             * Paste handler method. Used by task recorder to record pasting values.
             * @internal
             * @param $filterField The instance of the filter field. This is of type $dyn.controls.FilterField.
             * @param $valueIndex The index of the filter value (filter fields may have multiple values).
             */
            function paste_Value($filterField, $valueIndex) {
                return function (args) {
                    if (args.length !== 2) {
                        return;
                    }
                    // Type any for param $filterField is used because of below logic as Values of FilterField is PotentialObservableArray<PotentialObservable<string>>
                    // Now we can not call if the type is PotentialObservable, also can not use setvalue as we do not know property names
                    // PotentialObservable is used because same type is used for unwrapped innstances
                    var currentValue = $dyn.value($filterField.Values)[$valueIndex];
                    if ($dyn.isObservable(currentValue)) {
                        currentValue(args[1]);
                    }
                    // TODO: Deliverable 259153
                    // var recordingReference = args[0];
                    // var value = args[1];
                    // while ($dyn.value($filterField.RecordingReferences).length < $valueIndex + 1) {
                    //    //Using space, because empty value will be chopped by server serializer
                    //    $filterField.RecordingReferences.push(" ");
                    // }
                    // var recordingReferenceInstance = $dyn.value($filterField.RecordingReferences)[$valueIndex];
                    // recordingReferenceInstance(recordingReference);
                    // var values = $dyn.value($filterField.Values);
                    // values[$valueIndex](value);
                    // $dyn.observe(values[$valueIndex], function (newValue) {
                    //    if (newValue !== value) {
                    //        //Using space, because empty value will be chopped by server serializer
                    //        recordingReferenceInstance(" ");
                    //        return false;
                    //    }
                    // });
                };
            }
            FilterField.paste_Value = paste_Value;
            /**
             * Returns a function that will request a lookup for a given filter field.
             * @param $filterField The instance of the filter field.
             */
            function OnRequestPopup($filterField) {
                return function (args) {
                    var $filterManager = $filterField.Root ? $filterField.Root.FilterManager : undefined;
                    if ($filterManager && $filterManager.RequestLookupForm && $filterManager.FilterToApply) {
                        var controlName = this.Name;
                        var popupId = args[0];
                        var displayedValue = this.displayedValue ? this.displayedValue() : "";
                        var isInFilterMode = this.isDisplayedValueDirty ? this.isDisplayedValueDirty() : false;
                        // Type any is used because DataSource of FilterField control should be type IFieldExpression
                        // However BaseControl has a same name property of DataSource which is of different type
                        var unwrappedFilterExpression = $dyn.util.unwrapFilterExpression($filterField.DataSource);
                        $filterManager.FilterToApply(unwrappedFilterExpression);
                        $dyn.callFunction($filterManager.RequestLookupForm, $filterManager, [controlName, popupId, displayedValue, isInFilterMode]);
                    }
                };
            }
            FilterField.OnRequestPopup = OnRequestPopup;
        })(FilterField = controls.FilterField || (controls.FilterField = {}));
        FilterField.prototype.Operator = FilterField.Operators.is;
        FilterField.prototype.Values = [];
        FilterField.prototype.FieldCapability = null;
        FilterField.prototype.RecordingReferences = [];
        FilterField.prototype.postRenderValuesSubscriptions = undefined;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FilterField.js.map
